export const LD_FLAGS = {
    CREDIT_APPLICATION_ENABLED: 'dotcom-credit-application-enabled'
}